// extracted by mini-css-extract-plugin
export default {"buttons":"PreregistersInCacheModal_buttons__7PzmH","text":"PreregistersInCacheModal_text__rg1ze"};